import type { Theme } from '@src/app/themes';
import {
  AbsenceIcon,
  CallIcon,
  ContractIcon,
  ShippingIcon,
} from '@src/shared/ui/icons';
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@src/shared/ui/List';
import { Box } from '@src/shared/ui/layout';

type TaskColor = 'red' | 'green' | 'grey' | 'orange';
type TaskIconType = 'document' | 'calendar' | 'phone' | 'truck';

interface Task {
  id: number;
  name: string;
  date: string;
  icon: TaskIconType;
  color: TaskColor;
}

const COLOR_MAP = (theme: Theme): Record<TaskColor, string> => ({
  red: theme.palette.red[600],
  green: theme.palette.green[600],
  grey: theme.palette.grey[800],
  orange: theme.palette.orange[600],
});

const TASKS: Task[] = [
  {
    id: 1,
    name: 'Import documentation',
    date: '10.02.2026',
    icon: 'document',
    color: 'red',
  },
  {
    id: 2,
    name: 'Declaration',
    date: '10.02.2026',
    icon: 'document',
    color: 'green',
  },
  {
    id: 3,
    name: 'Inspection',
    date: '10.02.2026',
    icon: 'document',
    color: 'grey',
  },
  {
    id: 4,
    name: 'Vacation Approval',
    date: '10.02.2026',
    icon: 'calendar',
    color: 'red',
  },
  {
    id: 5,
    name: 'Civils Approval',
    date: '10.02.2026',
    icon: 'calendar',
    color: 'green',
  },
  {
    id: 6,
    name: 'Status update call',
    date: '10.02.2026',
    icon: 'phone',
    color: 'grey',
  },
  {
    id: 7,
    name: 'Client phone call',
    date: '10.02.2026',
    icon: 'phone',
    color: 'orange',
  },
  {
    id: 8,
    name: 'Client phone call',
    date: '10.02.2026',
    icon: 'phone',
    color: 'grey',
  },
  {
    id: 9,
    name: 'Shipping documents',
    date: '10.02.2026',
    icon: 'truck',
    color: 'orange',
  },
  {
    id: 10,
    name: 'Delivery process',
    date: '10.02.2026',
    icon: 'truck',
    color: 'grey',
  },
  {
    id: 11,
    name: 'Freight forwarding',
    date: '10.02.2026',
    icon: 'truck',
    color: 'green',
  },
  {
    id: 12,
    name: 'Import documentation',
    date: '10.02.2026',
    icon: 'document',
    color: 'grey',
  },
  {
    id: 13,
    name: 'Import documentation',
    date: '10.02.2026',
    icon: 'document',
    color: 'green',
  },
  {
    id: 14,
    name: 'Vacation Approval',
    date: '10.02.2026',
    icon: 'calendar',
    color: 'orange',
  },
];

function TaskIcon({ type, color }: { type: TaskIconType; color: TaskColor }) {
  const iconSx = (theme: Theme) => ({
    fontSize: 20,
    color: COLOR_MAP(theme)[color],
  });

  switch (type) {
    case 'document':
      return <ContractIcon sx={iconSx} />;
    case 'calendar':
      return <AbsenceIcon sx={iconSx} />;
    case 'phone':
      return <CallIcon sx={iconSx} />;
    case 'truck':
      return <ShippingIcon sx={iconSx} />;
  }
}

const StyleSheet = {
  list: {
    marginTop: '5px',
    overflow: 'auto',
  },
  listItem: (theme: Theme) => ({
    padding: '6px 20px',
    borderBottom: '1px solid',
    borderColor: 'grey.200',
    gap: '6px',
    '& .MuiListItemText-root': {
      margin: 0,
    },
    '& .MuiListItemText-secondary': {
      color: theme.palette.grey[800],
    },
  }),
  taskIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
export default function TasksList() {
  return (
    <List disablePadding sx={StyleSheet.list}>
      {TASKS.map((task) => (
        <ListItem key={task.id} sx={StyleSheet.listItem}>
          <ListItemAvatar>
            <Box sx={StyleSheet.taskIconWrapper}>
              <TaskIcon type={task.icon} color={task.color} />
            </Box>
          </ListItemAvatar>
          <ListItemText
            primary={task.name}
            secondary={task.date}
            slotProps={{
              primary: { variant: 'body2' },
              secondary: { variant: 'body3' },
            }}
          />
        </ListItem>
      ))}
    </List>
  );
}
